module.exports = __webpack_public_path__ + "img/9-6.11adba81.png";